module.exports = __webpack_public_path__ + "ea9e63377bb89bbe4d1d3a583b68ee20.png";